import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { rememberBusiness } from "@/lib/vocab";
import { rememberPhoneCountries } from "@/lib/phone";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const apply = useCallback((s) => {
    if (!s) return;
    document.documentElement.style.setProperty("--accent", s.accent_color);
    document.documentElement.style.setProperty("--ring", s.accent_color);
    document.title = s.company_name || "Fiableo";
    rememberBusiness(s.business === "transport" ? "transport" : "conciergerie");
    rememberPhoneCountries(s.phone_countries); // indicatifs du serveur (transport, lot T6) ; conciergerie : rien
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data); apply(data);
  }, [apply]);

  useEffect(() => { refresh(); }, [refresh]);

  return <SettingsContext.Provider value={{ settings, refresh, setSettings: (s) => { setSettings(s); apply(s); } }}>{children}</SettingsContext.Provider>;
}
